function printBlock(id, css) {
	var
		content = document.getElementById(id),
		css = `<link rel="stylesheet" href="${TEMPLATE_PATH}/css/print/${css}.css?t=8493" type="text/css" />`,
		wnd = window.open('','','left=50,top=50,width=800,height=640,toolbar=0,scrollbars=1,status=0');

	wnd.document.write('<div id="print" class="content">');
	wnd.document.write(css);
	wnd.document.write(content.innerHTML);
	wnd.document.write('</div>');
	wnd.document.close();
	wnd.focus();
	wnd.print();
	wnd.close();
	//content.innerHTML = strOldOne;
}
function number_format(number, decimals = 2, dec_point = ".", thousands_sep = " ") {
	let i, kw, kd;

	i = parseInt(number = (+number || 0).toFixed(decimals)) + "";
	kw = i.split(/(?=(?:\d{3})+$)/).join(thousands_sep);
	kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

	return kw + kd;
}
function array_unset_value(arr, val) {
	let i = arr.indexOf(val);
	if (i > -1)
		arr.splice(i, 1);

	return arr;
}
function in_array(val, arr) {
	return arr.indexOf(val) !== -1;
}